<template>
    <section id="amazing-slider" class="carousel slide carousel-fade card" data-ride="carousel">
        <div class="row m-0">
            <ol class="carousel-indicators pr-0 d-flex flex-column col-lg-3">
                <li v-for="(amazingOffer,index) in amazingOffers" :class="{active: (index == 0)? true: false}" data-target="#amazing-slider" :data-slide-to="index">
                    <h3 style="font-size:14px; margin:5px;">{{ amazingOffer.SchemaCode }}</h3>
                </li>
            </ol>
            <div class="carousel-inner p-0 col-12 col-lg-9">
                <img class="amazing-title" src="/assets/img/amazing-slider/amazing-title-01.png" alt="">
                <div v-for="(amazingOffer,index) in amazingOffers" :class="{'carousel-item' : true , active: (index == 0)? true: false }">
                    <div class="row m-0">
                        <div class="right-col col-5 d-flex align-items-center">
                            <router-link tag="a" :title="amazingOffer.ProductName" class="w-100 text-center" :to="{ name: 'product' , params: { productId: amazingOffer.ProductId , productName: amazingOffer.ProductName.replace(/\s+/g, '-') } }">
                                <img :src="amazingOffer.PicPath" :alt="amazingOffer.SchemaCode.replace(/\s+/g, '-') + ' ' +  amazingOffer.ProductName.replace(/\s+/g, '-')" :title="amazingOffer.ProductName.replace(/\s+/g, '-')" class="img-fluid" @error="imageLoadOnError">
                            </router-link>
                        </div>
                        <div class="left-col col-7">
                            <h2 class="product-title">
                                <router-link :title="amazingOffer.ProductName" :to="{ name: 'product' , params: { productId: amazingOffer.ProductId , productName: amazingOffer.ProductName.replace(/\s+/g, '-') }}"> {{ amazingOffer.ProductName }} </router-link>
                            </h2>
                            <div  class="price" v-if="amazingOffer.Price != 0 && isUserLogined">
                                <span v-if="amazingOffer.IsAvailable" class="title">قیمت :</span>
                                <span v-else class="title stateIsAvailable">وضعیت محصول :</span>
                                <div>
                                    <div class="pd-r-70" v-if="amazingOffer.IsAvailable">
                                        <del v-if="amazingOffer.DiscountPercent != 0"><span>{{ amazingOffer.Price | formatNumber }}<span>ریال</span></span></del>
                                        <ins><span>{{ amazingOffer.FinalPrice | formatNumber }}<span>ریال</span></span></ins>
                                        <span v-if="amazingOffer.DiscountPercent != 0" class="discount-percent">{{ amazingOffer.DiscountPercent }} تخفیف</span>
                                    </div>
                                    <div class="center" v-else>
                                        <span class="unAvailable">ناموجود</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <span class="title">قیمت :</span>
                                <div class="callToMain">
                                    <span class="call">جهت استعلام قیمت تماس بگیرید</span>
                                </div>
                            </div>
                            <hr />
                            <ul class="list-group">
                                <!--<li class="list-group-item"><span class="title">وضعیت محصول :</span>  {{amazingOffer.IsAvailable ? 'موجود': 'ناموجود' }}</li>-->
                                <li class="list-group-item" v-if="!(amazingOffer.GuaranteeDescription == null || amazingOffer.GuaranteeDescription == '')"><span class="title">شرح ضمانت :</span>  {{ amazingOffer.GuaranteeDescription }} </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        computed: {
            amazingOffers: function () {
                return this.$store.getters.readAmazingOffers;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-image-available.png";
            },
            beforeMount() {
                this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
            }
        }
    }
</script>

<style scoped>
    .carousel-indicators {
        justify-content: unset;
    }
    .stateIsAvailable {
        padding-bottom: 15px;
        display: inline-block;
    }
    #amazing-slider .carousel-inner .carousel-item .row .left-col .list-group .list-group-item {
        border: none;
        padding: 6px !important;
    }
    .pd-r-70 {
        padding-right: 70px;
    }

    .unavailable-product {
top:10px;
left:25px;
width:unset;
}
</style>